import types from '../types';

import { getResetedCheckboxGroupSubOptionsState } from '.';

/**
 * @param {types.CheckBoxOrRadioOption[]} options
 * @returns {types.CheckBoxOrRadioOption[]}
 */
const getResetedCheckboxGroupState = options => {
    if (!options || !Array.isArray(options) || !options.length) {
        throw new Error('Options are missing!');
    }

    return options.map(option => {
        if (option.subOptions && option.subOptions.length) {
            return {
                ...option,
                checked: false,
                subOptions: getResetedCheckboxGroupSubOptionsState(
                    option.subOptions
                )
            };
        }

        return {
            ...option,
            checked: false
        };
    });
};

export default getResetedCheckboxGroupState;
